import { LinkTo } from '@ember/routing';
import { t } from 'ember-intl';
import Tile from '../tile';
import Svg from 'tio-employee/components/svg';

<template>
  <LinkTo @route="authenticated.college-planning-mentors.index">
    <Tile @headerText="Education Mentors">
      <:description>
        {{t "dashboard_tiles.college_planning_mentors"}}
      </:description>
      <:image>
        <Svg
          @name="college-planning"
          width="100%"
          height="100%"
          role="img"
          aria-label={{t "svg.mentoring"}}
          class="lg:max-h-56 xl:max-h-full"
        />
      </:image>
    </Tile>
  </LinkTo>
</template>
